module.exports = __webpack_public_path__ + "static/media/feature11.4676c50c.png";